module.exports = __webpack_public_path__ + "img/top-bg-cjhd.0b17325e.png";